<template>
  <div v-editable="blok">
    <b-toast
      id="basket-voucher-verified"
      :toaster="blok.position"
      :variant="'light'"
      solid
      no-auto-hide
      no-close-button
    >
      <div class="container product-notification p-0">
        <b-row>
          <b-col sm="9" class="pb-3 pb-md-0">
            We've confirmed the voucher
            <b>{{ valid_voucher.code }}</b>. Your new total is
            <b>{{ total | currency('£') }} ({{ per_person | currency('£') }} per person)</b>
            <span v-if="(valid_voucher.price - total)>0">
              , meaning you save
              <b>{{ (valid_voucher.price - total) | currency('£') }}</b> on your order.
            </span>
          </b-col>
          <b-col sm="3" @click="closeVoucher()">
            <button class="btn cta-button btn-block">OK</button>
          </b-col>
        </b-row>
      </div>
    </b-toast>
    <b-toast
      id="basket-getstarted"
      :toaster="blok.position"
      :variant="'light'"
      solid
      no-auto-hide
      no-close-button
    >
      <div class="container product-notification p-0">
        <b-row>
          <b-col sm="9" class="pb-3 pb-md-0">
            <span v-if="meal_preferences.shipping_date">
              Your delivery date is
              <b>{{ meal_preferences.shipping_date.date | niceDate }}</b>
            </span>
            <span v-if="applied_voucher">
              and after selecting {{ basket_config.min_count }} recipes you can click 'Apply voucher' to use the code
              <b>{{ applied_voucher }}</b>
            </span>.&nbsp;
            <span
              v-if="!applied_voucher"
            >Select {{ basket_config.min_count }} recipes to continue</span>
          </b-col>
          <b-col sm="3" @click="closeStart()">
            <button class="btn cta-button btn-block">OK</button>
          </b-col>
        </b-row>
      </div>
    </b-toast>
    <b-toast
      id="basket-added"
      :toaster="blok.position"
      :variant="'light'"
      solid
      auto-hide-delay="10000"
      no-close-button
    >
      <div class="contaner product-notification">
        Item added:
        <b-row v-if="last_added_item">
          <b-col sm="12">
            <b-row class>
              <!-- <b-col class="title" sm="12">{{ last_added_item.recipe.title }}</b-col>
              <b-col class="image" sm="12">
                <img width="100%" :src="last_added_item.recipe.image_urls.m">
              </b-col>-->
              <b-col class="price" sm="12">
                Box Price: {{ total | currency('£') }}
                <span
                  v-if="size>0"
                >({{size}} {{ size | pluralize('meal', 'meals')}})</span>
                <div class="recipe-price-per-person">
                  <span v-mny="{ input: per_person, currency: 'GBP' }"></span>&nbsp;per person
                </div>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="12" class="mb-2">
            <basket-validation></basket-validation>
          </b-col>
          <!-- <b-col class="mb-2 pr-1" cols="6" v-if="true">
            <button
              @click="removeAndClose(last_added_item)"
              class="btn cta-button btn-secondary"
            >Remove</button>
          </b-col>-->
          <b-col class="mb-2" cols="12" v-if="true">
            <button @click="close()" class="btn cta-button btn-secondary">OK</button>
          </b-col>
          <b-col sm="12" @click="close()" v-if="link">
            <a :href="link" class="btn cta-button btn-block">{{ linkText }}</a>
          </b-col>
        </b-row>
      </div>
    </b-toast>
    <b-toast
      id="basket-removed"
      :toaster="'b-toaster-bottom-left'"
      :variant="'light'"
      solid
      auto-hide-delay="10000"
      no-close-button
    >
      <div class="contaner product-notification">
        Your item was removed.
        <b-row v-if="removed_item">
          <b-col sm="12">
            <b-row class="product-notification">
              <b-col class="price" sm="12">
                Box Price: {{ total | currency('£') }}
                <span
                  v-if="size>0"
                >({{size}} {{ size | pluralize('meal', 'meals')}})</span>
                <div class="recipe-price-per-person">
                  <span v-mny="{ input: per_person, currency: 'GBP' }"></span>&nbsp;per person
                </div>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="12" class="mb-3">
            <basket-validation></basket-validation>
          </b-col>
          <b-col sm="12" class="mb-2">
            <button @click="close()" class="btn cta-button btn-secondary btn-block">OK</button>
          </b-col>
          <b-col sm="12" @click="close()" v-if="link">
            <a :href="link" class="btn cta-button btn-block">{{ linkText }}</a>
          </b-col>
        </b-row>
      </div>
    </b-toast>
  </div>
</template>
<script>
import { mapActions, mapState, mapGetters } from "vuex";

import { basketBase } from "../../../components/cart/basketBase";
import { setTimeout } from 'timers';
import BasketValidation from './BasketValidation';

export default {
    name: 'basket-notifications',
    mixins: [basketBase],
    props: {
        blok: Object
    },
    data: () => {
        return {
            removed_item: null
        }
    },
    components: {
        BasketValidation
    },
    computed: {
        ...mapState({
            basket_config: state => state.basket.config,
            discount: state => state.basket.discountPercent,
            meal_preferences: state => state.profile.meal_preferences,
            basket: state => state.basket,
            applied_voucher: state => state.voucher.code,
            valid_voucher: state => state.basket.voucher
        }),
        ...mapGetters({
            last_added_item: 'basket/last_added_item',
            size: 'basket/size',
            ready: 'basket/ready'
        }),
        per_person: function() {
            return this.total / this.meal_preferences.people;
        },
        link: function() {
            const f = this.$options.filters;
            if(!this.ready) {
                return this.blok.basket_link.cached_url ? f.formatSbInternalLink(this.blok.basket_link.cached_url) : null;
            }
            const purchase_link = f.appendLegacyOnboardingQuery(
                f.formatSbInternalLink(this.blok.purchase_link.cached_url),
                this.meal_preferences,
                this.basket);
            return this.blok.purchase_link.cached_url ? purchase_link : null; 
        },
        linkText: function() {
            if(!this.ready) {
                return this.blok.basket_link_text;
            }
            return this.blok.purchase_link_text;
        }
    },
    mounted: function() {
        this.$on('itemRemoved', (v) => {
            this.removed_item = v;
            setTimeout((v) => {
                this.$bvToast.show('basket-removed');
            }, 500);
        })
        this.$bvToast.show('basket-getstarted');
    },
    methods: {
        removeAndClose: function(item) {
            this.removeFromBasket(item);
            this.$bvToast.hide('basket-added');
            this.$bvToast.hide('basket-removed');
        },
        close: function() {
            this.$bvToast.hide('basket-added');
            this.$bvToast.hide('basket-removed');
            this.$bvToast.hide('basket-getstarted');
            this.$bvToast.hide('basket-shippingchanged');
        },
        closeStart: function() {
            this.$bvToast.hide('basket-getstarted');
        },
        closeVoucher: function() {
            this.$bvToast.hide('basket-voucher-verified');
        }
    },
    watch: {
        size: function(n,o) {
            if(n>o) {
                this.$bvToast.hide('basket-getstarted');
                this.$bvToast.show('basket-added');
            } 
            if(n==0) {
                this.close();
                this.$bvToast.show('basket-getstarted');
            }
        },
        'meal_preferences.shipping_date': function(v) {
            this.$bvToast.show('basket-getstarted');
        },
        'valid_voucher.code': function(n) {
            if(this.valid_voucher.price>0) {
                this.$bvToast.show('basket-voucher-verified');
            }
        }
    },
}
</script>
